module.exports = __webpack_public_path__ + "img/contactImg2.e51c0437.png";